<template>
  <div style="padding: 20px; overflow: scroll; height: 100%" :style="{ background: isLaunchModal ? '#f5fff5' : '' }">
    <el-button @click.prevent="close" style="position: absolute; right: 10px; top: 10px" size="small" plain><i
        class="fas fa-xmark"></i></el-button>
    <h3 v-if="isLaunchModal" style="margin-top: -10px">Launch modal</h3>
    <h3 v-if="!isLaunchModal" style="margin-top: -10px">Automation editor</h3>
    <p v-if="isLaunchModal" style="font-size: 11px" class="colorBlue">
      Some fields are not editable in "Manual Launch Modal"
    </p>
    <el-form ref="automationForm" :model="form" :rules="validationRules" label-width="140px" size="mini">
      <el-form-item label="Automation name" prop="name">
        <el-input v-model="form.name" placeholder="Automation name" maxlength="80" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="Tags" prop="automation_tags">
        <el-select v-model="form.automation_tags" style="width: 100%" filterable clearable :multiple="true"
          placeholder="Select Tags (optional)" :allow-create="true">
          <el-option v-for="item in tagsAvailable" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Automation type" prop="automation_type">
        <el-select v-model="form.automation_type" placeholder="Select Automation type" :disabled="isLaunchModal"
          class="longInput">
          <el-option label="CRON (auto check)" value="cron"></el-option>
          <el-option label="Manual" value="manual"></el-option>
          <el-option label="Instant Event" value="event"></el-option>
          <el-option label="Delayed Event" value="cron_event"></el-option>
          <!-- <el-option label="Campaign" value="campaign"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="Type / User type" prop="user_type">
        <el-select v-model="form.user_type" placeholder="Select user type" :disabled="isLaunchModal" autocomplete="off"
          class="longInput" @change="
            () => {
              form.content_type = null;
            }
          ">
          <el-option label="Parents & Staff - User" value="parents_staff"></el-option>
          <el-option label="Per School" value="per_school"></el-option>
          <el-option label="Parents - User" value="parents"></el-option>
          <el-option label="Staff - User" value="staff"></el-option>
          <el-option label="Admins Contacts" value="admin_contacts"></el-option>
          <el-option label="Unregistered Wonde users" value="unregistered_wonde_users"></el-option>
          <el-option label="Stap Data" value="step_journeys"></el-option>
          <el-option label="Superadmin - event/row" value="superadmin" :disabled="true"></el-option>
          <el-option label="Superadmin - stats (grouped)" value="superadmin_grouped"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Content type" prop="content_type" :disabled="!form.content_type || isLaunchModal">
        <el-select v-model="form.content_type" placeholder="Select Content type" :disabled="isLaunchModal"
          class="longInput">
          <el-option label="Email" value="email" :disabled="[
            'admin_contacts',
            'superadmin',
            'superadmin_grouped',
            'step_journeys',
          ].indexOf(form.user_type) > -1
            "></el-option>
          <el-option label="Notification (Post)" value="notice" :disabled="[
            'admin_contacts',
            'superadmin',
            'superadmin_grouped',
            'unregistered_wonde_users',
            'unregistered_wonde_users',
            'step_journeys',
          ].indexOf(form.user_type) > -1
            "></el-option>
          <el-option label="Slack" value="slack" :disabled="[
            'admin_contacts',
            'superadmin',
            'superadmin_grouped',
            'step_journeys',
          ].indexOf(form.user_type) > -1
            "></el-option>
          <el-option label="SMS" value="sms" :disabled="[
            'admin_contacts',
            'superadmin',
            'superadmin_grouped',
            'unregistered_wonde_users',
            'step_journeys',
          ].indexOf(form.user_type) > -1
            "></el-option>
          <el-option label="Mobile push notifications" value="push_notifications" :disabled="[
            'admin_contacts',
            'superadmin',
            'superadmin_grouped',
            'unregistered_wonde_users',
            'step_journeys',
          ].indexOf(form.user_type) > -1
            "></el-option>
          <el-option label="Script" :disabled="[
            'per_school',
            'parents_staff',
            'step_journeys',
            'unregistered_wonde_users',
          ].indexOf(form.user_type) == -1
            " value="script"></el-option>
          <!-- <el-option
            label="Push Notification via App"
            value="push_notification"
          ></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="Template" prop="template" v-if="
        form.content_type == 'slack' ||
        form.content_type == 'sms' ||
        form.content_type == 'push_notifications'
      ">
        <el-select v-model="field" placeholder="Show tag" style="width: 270px" filterable autocomplete="off" clearable
          v-if="form.user_type != 'superadmin_grouped'" class="longInput">
          <el-option v-for="item in fieldOptions" :key="item.value" :label="item.value" :value="item.value">
          </el-option></el-select>
        <span v-if="form.content_type == 'slack' && form.repeating == 'daily_stats'">Use {school.name} for school name,
          {count} for matched count and
          {date}</span>
        <span v-if="field" @click="copyText(selectedField)" style="
            display: inline-block;
            width: 340px;
            line-height: 30px;
            padding-left: 5px;
          ">
          {{ selectedField }}
        </span>
        <el-input type="textarea" v-model="form.template" maxlength="300" show-word-limit
          style="padding-top: 5px"></el-input>
      </el-form-item>
      <el-form-item label="Email ID" v-if="form.content_type === 'email'" prop="content_template_id">
        <el-select v-model="form.content_template_id" placeholder="Select Email" :disabled="isLaunchModal" filterable
          autocomplete="off" auto-complete="off" class="longInput">
          <el-option v-for="item in email_templates" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Notification ID" v-if="form.content_type === 'notice'" prop="content_template_id">
        <el-select v-model="form.content_template_id" placeholder="Select Notification (Post)" :disabled="isLaunchModal"
          filterable style="width: 300px">
          <el-option v-for="item in filtered_notice_templates" :key="item.id" :label="item.template_title"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item
        label="SMS template"
        v-if="form.content_type === 'sms'"
        prop="content_template_id"
      >
        <el-select
          v-model="form.content_template_id"
          placeholder="Select SMS"
          :disabled="isLaunchModal"
          filterable
          style="width: 300px"
        >
          <el-option label="Sms" value="sms"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="Script ID" v-if="form.content_type === 'script' && form.user_type == 'per_school'"
        prop="script_name">
        <el-select v-model="form.script_name" placeholder="Select Script" :disabled="isLaunchModal" filterable
          style="width: 300px">
          <el-option label="New term" value="school_new_term"></el-option>
          <el-option label="Wonde sync" value="sync_wonde_school"></el-option>
          <el-option label="Remove user schools" value="remove_user_schools"></el-option>
          <el-option label="Remove non user data" value="remove_non_user_data"></el-option>
          <el-option label="Remove marked users" value="remove_marked_users"></el-option>
          <el-option label="Unverify wonde users " value="unverify_wonde_users"></el-option>
          <el-option label="Check for missing journeys" value="check_for_missing_journeys"></el-option>
          <el-option label="Invalidate wonde users" value="invalidate_wonde_users"></el-option>
          <el-option label="Verify co2 calculations" value="co2_calculations"></el-option>

          <el-option label="Update Wonde Users Status" value="update_wonde_users_status"></el-option>
          <el-option label="Remove Wonde Unvalidated User Schools"
            value="remove_wonde_unvalidated_user_schools"></el-option>

          <el-option label="New Year Script" value="move_up_year"></el-option>
          <el-option label="Send Login emails" value="resend_login_emails"></el-option>
          <el-option label="Send Service emails" value="service_emails"></el-option>
          <el-option label="Hide old notices" value="hide_old_notices"></el-option>
          <el-option label="Daily queue schedule" value="daily_queueing"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Script ID" v-if="
        form.content_type === 'script' && form.user_type == 'parents_staff'
      " prop="script_name">
        <el-select v-model="form.script_name" placeholder="Select Script" :disabled="isLaunchModal" filterable
          style="width: 300px">
          <!-- <el-option
            label="Update Wonde Users Status"
            value="update_wonde_users_status"
          ></el-option>
          <el-option
            label="Remove Wonde Unvalidated User Schools"
            value="remove_wonde_unvalidated_user_schools"
          ></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item label="Script ID" v-if="form.content_type === 'script' && form.user_type == 'step_journeys'"
        prop="script_name">
        <el-select v-model="form.script_name" placeholder="Select Script" :disabled="isLaunchModal" filterable
          style="width: 300px">
          <el-option label="Stap Data Journeys Count" value="step_journeys_journeys_count"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Send notification ?" v-if="form.content_type === 'notice'" prop="send_notification">
        <el-select v-model="form.send_notification" placeholder="Send notification ?">
          <el-option label="No" :value="0"></el-option>
          <el-option label="Yes" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="form.selection_type ? 'Org blacklist' : 'Org whitelist'" prop="organization_ids"
        style="color: green !important" :erroras="form.selection_type ? 'School blacklist' : ''"><el-switch
          v-model="form.selection_type" style="float: right" title="Whitelist/blacklist schools"></el-switch>
        <OrgSelectionAdmin @return-selection="updateOrgIds" v-if="showSchoolFilter" :multiple="true"
          :collapseTags="false" :initialSelection="form.organization_ids" style="width: 94%" />
      </el-form-item>
      <el-form-item label="From label for posts" prop="from">
        <el-select v-model="form.from_label" placeholder="Select From label" :disabled="form.content_type != 'notice'"
          class="longInput">
          <el-option label="Homerun Team " value="homerun_team"></el-option>
          <el-option label="School info" value="school_info" :disabled="form.user_type != 'per_school'"></el-option>
          <el-option label="Jenny" value="jenny"></el-option>
          <el-option label="Denise" value="denise"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="When to run Autom." prop="when_to_launch">
        <el-select v-model="form.when_to_launch" placeholder="When it should run/launch" :disabled="form.automation_type != 'cron' &&
          form.automation_type != 'cron_event'
          " @change="
            form.months = [];
          form.weekdays = [];
          " class="longInput">
          <!-- <el-option label="New term" value="new_term"></el-option> -->
          <el-option label="Daily" value="daily"></el-option>
          <el-option label="Custom" value="custom"></el-option>
          <el-option label="Specific date" value="specific"></el-option>
          <el-option label="On demand (manual queuing)" value="on_demand"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Months" v-if="form.when_to_launch == 'custom'">
        <el-button v-if="form.months.length == 0" class="selectAllBtn"
          @click="form.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]">
          Select all
        </el-button>
        <el-button v-if="form.months.length > 0" class="selectAllBtn" @click="form.months = []">
          Deselect all
        </el-button>
        <el-checkbox-group v-model="form.months">
          <el-checkbox-button v-for="month in months" :label="month.v" :key="month.v">{{ month.n }}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Weeks" v-if="form.when_to_launch == 'custom'">
        <el-checkbox-group v-model="form.weeks" @change="weeksChanged" :disabled="form.days.length > 0">
          <el-checkbox-button v-for="week in weeks" :label="week.v" :key="week.v">{{ week.n }}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Weekdays" v-if="
        form.when_to_launch == 'custom' || form.when_to_launch == 'weekly'
      ">
        <el-button v-if="form.weekdays.length == 0" class="selectAllBtn" @click="form.weekdays = [1, 2, 3, 4, 5, 6, 7]"
          :disabled="form.days.length > 0">
          Select all
        </el-button>
        <el-button v-if="form.weekdays.length > 0" class="selectAllBtn" @click="form.weekdays = []"
          :disabled="form.days.length > 0">
          Deselect all
        </el-button>
        <el-checkbox-group v-model="form.weekdays" :disabled="form.days.length > 0">
          <el-checkbox-button v-for="weekday in weekdays" :label="weekday.v" :key="weekday.v">{{ weekday.n
            }}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Days" v-if="
        form.when_to_launch == 'custom' || form.when_to_launch == 'weekly'
      ">
        <!-- <el-button
          v-if="form.weekdays.length == 0"
          class="selectAllBtn"
          @click="form.weekdays = [1, 2, 3, 4, 5, 6, 7]"
        >
          Select all
        </el-button>
        <el-button
          v-if="form.weekdays.length > 0"
          class="selectAllBtn"
          @click="form.weekdays = []"
        >
          Deselect all
        </el-button> -->
        <el-checkbox-group v-model="form.days" :disabled="form.weekdays.length > 0 || form.weeks.length > 0">
          <el-checkbox-button v-for="day in days" :label="day.v" :key="day.v">{{
            day.n
            }}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Specific Dates" v-if="
        form.when_to_launch === 'specific' &&
        (form.automation_type == 'cron' ||
          form.automation_type == 'cron_event')
      ">
        <el-date-picker type="dates" placeholder="Pick a date" v-model="form.specific_date"
          style="width: 100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="Time" v-if="
        form.when_to_launch &&
        (form.automation_type == 'cron' ||
          form.automation_type == 'cron_event')
      ">
        <el-select v-model="form.specific_time" placeholder="Pick a time" :disabled="form.automation_type != 'cron' &&
          form.automation_type != 'cron_event'
          ">
          <el-option label="After midnight (starts 0am)" value="after_midnight"></el-option>
          <el-option label="Early morning (starts 5am)" value="early_morning"></el-option>
          <el-option label="Late morning ( starts 10am)" value="late_morning"></el-option>
          <el-option label="Afternoon (starts 12pm)" value="afternoon"></el-option>
          <el-option label="Early evening (starts 5pm)" value="early_evening"></el-option>
          <el-option label="Late evening (starts 7pm)" value="late_evening"></el-option>
          <el-option label="Night (starts 9pm)" value="night"></el-option>
          <el-option label="All day (6am to 9pm)" value="all_day"></el-option>
        </el-select>
        <!-- <el-time-select
          placeholder="Pick a time"
          v-model="form.specific_time"
          :picker-options="{
            start: '04:00',
            step: '00:20',
            end: '23:59',
          }"
          format="hh:mm A"
        ></el-time-select> -->
      </el-form-item>
      <el-form-item v-for="(rule, index) in form.custom_rules" :label="'Custom Rule ' + (index + 1)"
        :key="'crule' + index" prop="value">
        <div style="background: #e9f7ff; padding: 2px; border: 1px solid #b7e5ff">
          <el-select v-model="rule.custom_selection" placeholder="Custom selection" style="width: 250px">
            <el-option label="No messages sent in actions log (h)" value="actions_log_check"></el-option>
            <el-option label="User created within days" value="new_user"></el-option></el-select><el-input label="value"
            v-model="rule.value" placeholder="Value" style="width: 100px"></el-input>
          <el-button @click.prevent="removeCustomRule(index)" style="float: right" size="small" type="danger"
            plain>X</el-button>
        </div>
        <hr style="background-color: #f9f9f9" />
      </el-form-item>
      <el-form-item label="Limit Sends" prop="repeating">
        <el-select v-model="form.repeating" placeholder="Repeating" :dis="form.automation_type == 'manual'"
          :disabled="isLaunchModal" class="longInput">
          <el-option label="One off" value="one_off"></el-option>
          <el-option label="Once a week" value="once_week"></el-option>
          <el-option label="Once biweekly" value="once_biweek"></el-option>
          <el-option label="Once a month" value="once_month"></el-option>
          <el-option label="Once a quarter" value="once_quarter"></el-option>
          <el-option label="Once a year" value="once_year"></el-option>
          <el-option label="Multiple times" value="multiple_times"></el-option>
          <el-option label="Daily - stats" value="daily_stats"></el-option>
        </el-select>
        <span v-if="
          [
            'parents_staff',
            'admin_contacts',
            'parents',
            'staff',
            'superadmin_grouped',
          ].indexOf(form.user_type) > -1
        " style="padding-left: 3px">
          per user</span>
        <span v-if="['per_school'].indexOf(form.user_type) > -1" style="padding-left: 3px">
          per school</span>
        <span v-if="form.user_type === 'unregistered_wonde_users'" style="padding-left: 3px">
          per wonde user</span>
      </el-form-item>
      <el-form-item label="Daily stats field" prop="repeating_field" v-if="form.repeating == 'daily_stats'">
        <el-select v-model="form.extra_options.repeating_field" placeholder="Field">
          <el-option v-for="item in fieldOptions" :key="item.value" :label="item.value" :value="item.value">
          </el-option></el-select>
      </el-form-item>
      <el-form-item label="Expire" prop="expire">
        <el-date-picker type="date" placeholder="Pick an expiry date" v-model="form.expire"
          style="width: 300px"></el-date-picker>
      </el-form-item>
      <el-form-item label="Trigger Frequency" prop="frequency" v-if="form.repeating == 'daily_stats'">
        <el-input label="Frequency (every)" v-model="form.extra_options.frequency" placeholder="Every nth"
          style="width: 170px"></el-input>
      </el-form-item>
      <div v-if="form.rules.length > 0" style="
          background: #ecf5ff;
          padding-top: 5px;
          padding-right: 5px;
          padding-bottom: 1px;
          border: 1px solid #b2d8ff;
        ">
        <el-form-item v-for="(rule, index) in form.rules" :label="'Rule ' + (index + 1)" :key="'rule' + index"
          prop="value">
          <el-row>
            <el-select v-model="rule.field" placeholder="Field" style="width: 250px" @change="
              (e) => {
                if (fieldOptionsObj[rule.field]) {
                  if (
                    fieldOptionsObj[rule.field].type == 'timestamp' ||
                    fieldOptionsObj[rule.field].type == 'unix_timestamp'
                  ) {
                    rule.comparison = '<=';
                  } else {
                    rule.comparison = '=';
                  }
                }
              }
            " filterable>
              <el-option v-for="item in fieldOptions" :key="item.value" :label="item.value" :value="item.value">
              </el-option></el-select>
            <el-select v-model="rule.event_value" placeholder="Event" v-if="rule.field == 'events.event'"
              :multiple="false" required :rules="{
                required: true,
                message: 'domain can not be null',
                trigger: 'blur',
              }">
              <el-option v-for="item in eventTypes" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
            <el-select v-model="rule.comparison" placeholder="Compare" style="width: 105px" @change="rule.value = null"
              v-if="
                fieldOptionsObj[rule.field] &&
                fieldOptionsObj[rule.field].type != 'timestamp' &&
                fieldOptionsObj[rule.field].type != 'unix_timestamp'
              ">
              <el-option label="!=" value="!="></el-option>
              <el-option label="=" value="="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="in array" value="in_array"></el-option>
              <el-option label="is NULL" value="is_null"></el-option>
              <el-option label="is NOT NULL" value="is_not_null"></el-option>
              <el-option v-if="rule.type == 'choices'" label="IN (separate with ',')" value="in"></el-option>
            </el-select>
            <el-select v-model="rule.comparison" v-if="
              fieldOptionsObj[rule.field] &&
              (fieldOptionsObj[rule.field].type == 'timestamp' ||
                fieldOptionsObj[rule.field].type == 'unix_timestamp')
            " style="width: 140px">
              <el-option label="Less than <" value="<="></el-option>
              <el-option label="Greater than >" value=">="></el-option>
              <el-option label="Less than (custom)" value="<"></el-option>
              <el-option label="Greater than (custom)" value=">"></el-option>
              <el-option label="Doesn't exist (null)" value="is_null"></el-option>
            </el-select>

            <el-input label="value" v-if="
              rule.field &&
              (!fieldOptionsObj[rule.field] ||
                !fieldOptionsObj[rule.field].type)
            " v-model="rule.value" placeholder="Value" style="width: 100px"></el-input>
            <el-input label="value" v-if="
              fieldOptionsObj[rule.field] &&
              fieldOptionsObj[rule.field].type === 'number' &&
              rule.comparison != 'in_array'
            " type="number" v-model="rule.value" placeholder="Value" style="width: 100px"></el-input>
            <el-input v-model="rule.value" placeholder="Time" required v-if="
              fieldOptionsObj[rule.field] &&
              (rule.comparison == '<=' || rule.comparison == '>=') &&
              (fieldOptionsObj[rule.field].type === 'timestamp' ||
                fieldOptionsObj[rule.field].type === 'unix_timestamp')
            " style="width: 80px">
            </el-input>
            <el-input v-model="rule.value" placeholder="Separate with (,)" required v-if="
              fieldOptionsObj[rule.field] && rule.comparison == 'in_array'
            " style="width: 380px">
            </el-input>
            <el-select v-model="rule.time_unit" placeholder="Time Unit" :default-first-option="true" required v-if="
              fieldOptionsObj[rule.field] &&
              (rule.comparison == '<=' || rule.comparison == '>=') &&
              (fieldOptionsObj[rule.field].type === 'timestamp' ||
                fieldOptionsObj[rule.field].type === 'unix_timestamp')
            " :multiple="false" style="width: 80px">
              <el-option label="Weeks" value="weeks"></el-option>
              <el-option label="Minutes" value="minutes"></el-option>
            </el-select>
            <span v-if="
              fieldOptionsObj[rule.field] &&
              (rule.comparison == '<=' || rule.comparison == '>=') &&
              (fieldOptionsObj[rule.field].type === 'timestamp' ||
                fieldOptionsObj[rule.field].type === 'unix_timestamp')
            " style="font-size: 10px">
              ago</span>
            <el-select v-model="rule.value" placeholder="Dates" required v-if="
              fieldOptionsObj[rule.field] &&
              (rule.comparison == '<' || rule.comparison == '>') &&
              (fieldOptionsObj[rule.field].type === 'timestamp' ||
                fieldOptionsObj[rule.field].type === 'unix_timestamp')
            " :multiple="false" style="width: 150px">
              <el-option label="Now" value="now"></el-option>
              <el-option label="Today" value="today"></el-option>
              <el-option label="Start of week" value="this_week"></el-option>
              <el-option label="Start of month" value="this_month"></el-option>
              <el-option label="Start of this quarter" value="this_quarter"></el-option>
              <el-option label="Start of this year" value="this_year"></el-option>
            </el-select>
            <el-select v-model="rule.value" placeholder="Choices" v-if="
              fieldOptionsObj[rule.field] &&
              fieldOptionsObj[rule.field].choices
            " :multiple="rule.comparison == 'in' ? true : false">
              <el-option v-for="item in fieldOptionsObj[rule.field].choices" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
            <el-button @click.prevent="removeRule(index)" style="float: right" size="small" type="danger"
              plain>X</el-button>
          </el-row>
        </el-form-item>
      </div>
      <hr />
      <div style="text-align: right">
        <el-button @click.prevent="addRule" size="small" type="primary" plain
          :disabled="!form.automation_type || !form.user_type">+ <b>Field</b> rule</el-button>
        <!-- <el-button
          @click.prevent="addCustomRule"
          :disabled="!form.automation_type || !form.user_type"
          size="small"
          type="primary"
          plain
          >+ <b>Custom</b> rule</el-button
        > -->
      </div>
      <hr />
      <el-form-item v-if="isLaunchModal" label="Limit rows" prop="limit_rows">
        <el-input type="number" v-model="form.limit_rows" maxlength="4" style="width: 100px"></el-input>
      </el-form-item>
      <el-form-item label="Description" prop="description">
        <el-input type="textarea" v-model="form.description" maxlength="300" show-word-limit></el-input>
      </el-form-item>
      <hr />
      Preview data of:
      <el-form-item style="margin-left: -80px">
        <div v-if="form.user_type != 'step_journeys'">
          <el-button :disabled="!form.user_type || !form.content_type" type="warning"
            @click="getPreviewData('previewFirstOnly')"><i class="fa-solid fa-database"></i>
            <b>FIRST</b> school</el-button>
          <el-button :disabled="!form.user_type || !form.content_type" type="warning"
            @click="getPreviewData('previewAll')"><i class="fa-solid fa-database"></i>
            <b>ALL</b> schools (slow)</el-button>
          <el-button :disabled="!form.user_type || !form.content_type" type="warning"
            @click="getPreviewData('previewAfterIgnored')"><i class="fa-solid fa-database"></i>
            <b>ALL</b> without ignored users</el-button>
          <el-button :disabled="!form.user_type || !form.content_type" type="warning"
            @click="getPreviewData('previewAfterProcessing')"><i class="fa-solid fa-database"></i>
            <b>ALL</b> after processing</el-button>
        </div>
        <div v-if="form.user_type == 'step_journeys'">
          <el-button :disabled="!form.user_type || !form.content_type" type="warning"
            @click="getPreviewData('previewStapData2kMax')"><i class="fa-solid fa-database"></i> Max 2k
            results</el-button>
        </div>
        <el-popconfirm v-if="isLaunchModal" title="Are you sure you want to launch?" @confirm="launch">
          <el-button slot="reference" size="large" type="success" style="margin-top: 5px"><i
              class="fa-solid fa-rocket-launch"></i> Launch now</el-button>
        </el-popconfirm>
      </el-form-item>
      <div v-if="showPreviewCount" style="font-size: 12px">
        Total records in preview: {{ previewData.length }}
        <el-select v-model="previewFields" style="width: 60%" filterable clearable collapse-tags size="mini"
          :multiple="true">
          <el-option v-for="item in availablePreviewFields" :key="item" :label="item" :value="item">
          </el-option></el-select>
      </div>
      <div v-if="previewData.length > 0" v-loading="loadingPreview" style="
          overflow: scroll;
          max-width: 100%;
          max-height: 400px;
          border: 1px solid #ebebeb;
          background: white;
        ">
        <table id="previewTable" v-if="previewData.length > 0" style="background: white">
          <thead>
            <tr>
              <th class="headSmallCol">Row id</th>
              <th class="headSmallCol" :key="item" v-for="item in previewFields" :title="item">
                {{ item }}
              </th>
              <th v-if="form.user_type == 'parents_staff'">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="index" v-for="(row, index) in previewData">
              <td class="tableCol">{{ index + 1 }}</td>
              <td class="tableCol" :key="item + index" v-for="item in previewFields" :title="typeof row[item] == 'string' && row[item].length > 20
                ? row[item]
                : ''
                ">
                {{ row[item] }}
              </td>
              <td v-if="form.user_type == 'parents_staff'">
                <button @click.prevent="openParent(row['users.id'])">
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <el-form-item>
        <el-button v-if="!isLaunchModal" type="primary" @click="onSubmit" :disabled="!form.automation_type ||
          !form.user_type ||
          !form.content_type ||
          !form.repeating
          "><i class="fa-solid fa-database"></i> Save</el-button>
        <el-button v-if="!isLaunchModal" @click="$emit('close')">Cancel</el-button>
        <span v-if="form.content_type != 'script'" style="padding-left: 128px; padding-right: 5px"><span
            v-if="form.content_type === 'email'">Email/UserId</span><span
            v-if="!form.content_type || form.content_type != 'email'">UserId</span></span>
        <el-input v-if="form.content_type != 'script'" v-model="testRecipient" maxlength="30" max="30"
          style="width: 230px" placeholder="Enter userId/email"></el-input>
        <el-button v-if="form.content_type != 'script'" type="primary" @click="sendTest"
          :disabled="!testRecipient || !form.user_type || !form.content_type">Send Test</el-button>
      </el-form-item>
      <div>
        <table v-if="responseInfo.status" id="statusResponseTable">
          <h3 style="text-align: center">Response info/status:</h3>
          <tr>
            <td style="width: 200px">Status</td>
            <td>{{ responseInfo.status }}</td>
          </tr>
          <tr>
            <td>Total rows:</td>
            <td>{{ responseInfo.total_rows }}</td>
          </tr>
          <tr>
            <td>Processed rows:</td>
            <td>{{ responseInfo.total_processed }}</td>
          </tr>
          <tr>
            <td>Skipped rows:</td>
            <td>{{ responseInfo.skipped }}</td>
          </tr>
          <tr>
            <td>Total ignored user ids:</td>
            <td>
              {{
                responseInfo.total_ignored_users &&
                responseInfo.total_ignored_users.length
              }}
            </td>
          </tr>
          <tr>
            <td>Filtered school ids:</td>
            <td>{{ responseInfo.filtered_schools }}</td>
          </tr>
          <tr>
            <td>Ignored school ids:</td>
            <td>{{ responseInfo.ignored_organization_ids }}</td>
          </tr>
          <tr>
            <td>Ignored user ids:</td>
            <td>{{ responseInfo.total_ignored_users }}</td>
          </tr>
        </table>
      </div>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import ApiService from "@/services/ApiService";
import SingleParent from "@/modals/SingleParent.vue";
import {
  adminContactsFieldOptions,
  standardFieldOptions,
  perSchoolFieldOptions,
  unregisteredWondeFieldOptions,
  superadminGroupedFieldOptions,
  stapDataFieldOptions,
  eventTypes,
  schoolEventTypes,
} from "@/constants/automations";
import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "SingleAutomationModal",
  components: {
    OrgSelectionAdmin,
  },
  data() {
    return {
      testRecipient: "",
      standardFieldOptionsObj: {},
      adminContactsFieldOptionsObj: {},
      perSchoolFieldOptionsObj: {},
      unregisteredWondeFieldOptionsObj: {},
      stapDataFieldOptionsObj: {},
      email_templates: [],
      notice_templates: [],
      sms_templates: [],
      push_notifications_templates: [],
      showSchoolFilter: false,
      showPreviewCount: false,
      loadingPreview: false,
      field: null,
      disabled: false,
      timeout: null,
      weekdays: [
        { n: "Mon", v: 1 },
        { n: "Tue", v: 2 },
        { n: "Wed", v: 3 },
        { n: "Thu", v: 4 },
        { n: "Fri", v: 5 },
        { n: "Sat", v: 6 },
        { n: "Sun", v: 7 },
      ],
      months: [
        { n: "Jan", v: 1 },
        { n: "Feb", v: 2 },
        { n: "Mar", v: 3 },
        { n: "Apr", v: 4 },
        { n: "May", v: 5 },
        { n: "Jun", v: 6 },
        { n: "Jul", v: 7 },
        { n: "Aug", v: 8 },
        { n: "Sep", v: 9 },
        { n: "Oct", v: 10 },
        { n: "Nov", v: 11 },
        { n: "Dec", v: 12 },
      ],
      days: [
        { n: "1st", v: 1 },
        { n: "2", v: 2 },
        { n: "3", v: 3 },
        { n: "4", v: 4 },
        { n: "5", v: 5 },
        { n: "6", v: 6 },
        { n: "7", v: 7 },
        { n: "8", v: 8 },
        { n: "9", v: 9 },
        { n: "10", v: 10 },
        { n: "11", v: 11 },
        { n: "12", v: 12 },
        { n: "13", v: 13 },
        { n: "14", v: 14 },
        { n: "15", v: 15 },
        { n: "16", v: 16 },
        { n: "17", v: 17 },
        { n: "18", v: 18 },
        { n: "19", v: 19 },
        { n: "20", v: 20 },
        { n: "21", v: 21 },
        { n: "22", v: 22 },
        { n: "23", v: 23 },
        { n: "24", v: 24 },
        { n: "25", v: 25 },
        { n: "26", v: 26 },
        { n: "27", v: 27 },
        { n: "28", v: 28 },
        { n: "Last day", v: "last" },
      ],
      weeks: [
        { n: "All weeks", v: "all_weeks" },
        { n: "First week (1st to 7th)", v: "first_week" },
        { n: "Second week (8th to 14th)", v: "second_week" },
        { n: "Third week (15th to 22nd)", v: "third_week" },
        { n: "Last 7 days", v: "last_week" },
      ],
      tagsAvailable: [
        { label: "Mani", value: "mani" },
        { label: "Pooya", value: "pooya" },
        { label: "Matt", value: "matt" },
        { label: "Denise", value: "denise" },
        { label: "Jenny", value: "jenny" },
      ],
      previewData: [],
      previewFields: [],
      availablePreviewFields: [],
      form: {
        name: "",
        automation_tags: [],
        content_type: "notice",
        script_name: null,
        content_template_id: null,
        user_type: null,
        automation_type: null,
        from_label: "homerun_team",
        repeating: "one_off",
        when_to_launch: null,
        organization_ids: [],
        selection_type: false,
        rules: [],
        custom_rules: [],
        specific_date: null,
        description: "",
        specific_time: null,
        weekdays: [],
        days: [],
        months: [],
        weeks: [],
        send_notification: 0,
        template: null,
        expire: null,
        limit_rows: null,
        extra_options: {
          repeating_field: null,
          frequency: null,
        },
      },
      validationRules: {
        name: [
          {
            required: true,
            message: "Please input Automation name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 80,
            message: "Length should be 3 to 80",
            trigger: "blur",
          },
        ],
        user_type: [
          {
            required: true,
            message: "Please select User type",
            trigger: "change",
          },
        ],
        automation_type: [
          {
            required: true,
            message: "Please select Automation type",
            trigger: "change",
          },
        ],
        content_type: [
          {
            required: true,
            message: "Please select Content type",
            trigger: "change",
          },
        ],
        description: [
          {
            required: false,
            message: "Please enter description",
            trigger: ["change", "blur"],
          },
        ],
        content_template_id: [
          {
            required: true,
            message: "Please select a template",
            trigger: ["change", "blur"],
          },
        ],
        rules: [
          {
            type: "date",
            required: true,
            message: "Please pick a date",
            trigger: "change",
          },
        ],
        when_to_launch: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.$data.form.automation_type == "cron") {
                if (value == "custom") {
                  if (this.$data.form.months.length == 0) {
                    callback("Months selection required");
                  } else if (
                    this.$data.form.weeks.length == 0 &&
                    this.$data.form.weekdays.length == 0 &&
                    this.$data.form.days.length == 0
                  ) {
                    callback("Weeks or days required");
                  } else if (
                    this.$data.form.weeks.length > 0 &&
                    this.$data.form.weekdays.length == 0
                  ) {
                    callback("Weekday selection required");
                  } else if (!this.$data.form.specific_time) {
                    callback("Time selection required");
                  } else {
                    callback();
                  }
                } else if (value == "daily") {
                  if (!this.$data.form.specific_time) {
                    callback("Time selection required");
                  } else {
                    callback();
                  }
                } else if (
                  value == "specific" &&
                  this.$data.form.specific_date.length == 0
                ) {
                  callback("Specific days are required");
                } else if (value == null) {
                  callback("Selection required");
                } else {
                  if (!this.$data.form.specific_time) {
                    callback("Time selection required");
                  } else {
                    callback();
                  }
                  // callback();
                }
              } else {
                callback();
              }
              // console.log('This', this.$data.form.automation_type);
            },
          },
        ],
      },
      loading: false,
      responseInfo: {
        status: null,
        // status: "finished",
        // total_processed: 3,
        // total_rows: 3,
        // skipped: 0,
        // filtered_schools: [1],
        // ignored_organization_ids: [5, 2],
        // total_ignored_users: [1, 3],
      },
    };
  },
  computed: {
    fieldOptions() {
      if (this.form.user_type === "admin_contacts") {
        return adminContactsFieldOptions;
      } else if (this.form.user_type === "per_school") {
        return perSchoolFieldOptions;
      } else if (this.form.user_type === "superadmin_grouped") {
        return superadminGroupedFieldOptions;
      } else if (this.form.user_type === "unregistered_wonde_users") {
        return unregisteredWondeFieldOptions;
      } else if (this.form.user_type === "step_journeys") {
        return stapDataFieldOptions;
      } else {
        return standardFieldOptions;
      }
    },
    fieldOptionsObj() {
      if (this.form.user_type === "admin_contancts") {
        return this.adminContactsFieldsOptionsObj;
      } else if (this.form.user_type === "per_school") {
        return this.perSchoolFieldOptionsObj;
      } else if (this.form.user_type === "unregistered_wonde_users") {
        return this.unregisteredWondeFieldOptionsObj;
      } else if (this.form.user_type === "step_journeys") {
        return this.stapDataFieldOptionsObj;
      } else {
        return this.standardFieldOptionsObj;
      }
    },
    eventTypes() {
      if (this.form.user_type === "per_school") {
        return schoolEventTypes;
      } else {
        return eventTypes;
      }
    },
    filtered_notice_templates() {
      if (this.form.user_type === "per_school") {
        return this.notice_templates.filter(
          (itm) => itm.template_type == 1 || itm.template_type == 2
        );
      } else {
        return this.notice_templates.filter(
          (itm) => itm.template_type == 1 || itm.template_type == 3
        );
      }
    },
    selectedField() {
      return "%" + this.field + "%";
    },
  },
  props: {
    id: {
      type: Number || String,
      required: true,
    },
    isLaunchModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "form.user_type": function (newVal, oldVal) {
      if (newVal == "admin_contacts" || oldVal === "admin_contacts") {
        this.form.rules = [];
      }
      if (newVal == "admin_contacts" && this.form.content_type == "notice") {
        this.form.content_type = "email";
      }
    },
    // "form.manual_trigger": function (newVal) {
    //   if (newVal) {
    //     this.form.when_to_launch = null;
    //   }
    // },
    "form.content_type": function (newVal) {
      this.getTemplates(newVal);
    },
  },
  methods: {
    weeksChanged(data) {
      if (data.indexOf("all_weeks") > -1 && data.length > 1) {
        if (data[0] === "all_weeks") {
          this.form.weeks.splice(0, 1);
        } else {
          this.form.weeks.splice(0, data.length - 1);
        }
      }
    },
    getTemplates(category) {
      ApiService.automationsApi.getTemplates(category).then((resp) => {
        const data = resp.data;
        if (this.form.user_type === "admin_contacts") {
          this.email_templates = data.filter(
            (itm) => itm.content_type == "admin_contacts"
          );
        } else {
          if (category === "email") {
            this.email_templates = data.filter((itm) => {
              if (
                this.form.user_type == "admin_contacts" &&
                itm.user_type == "admin_contacts"
              ) {
                return itm;
              } else if (
                this.form.user_type == "unregistered_wonde_users" &&
                itm.user_type == "unregistered_wonde_users"
              ) {
                return itm;
              } else if (
                ["parents_staff", "parents", "staff"].indexOf(
                  this.form.user_type
                ) > -1 &&
                itm.user_type == "parents_staff"
              ) {
                return itm;
              }
            });
          } else if (category === "notice") {
            this.notice_templates = data;
          } else if (category === "sms") {
            this.sms_templates = data;
          }
        }
      });
    },
    getPreviewData(type) {
      this.loadingPreview = true;
      this.$refs["automationForm"].validate();
      const payload = {
        ...this.form,
        [type]: true,
      };
      ApiService.automationsApi
        .previewData(payload)
        .then((resp) => {
          const responseData = resp.data;
          this.showPreviewCount = true;
          if (responseData.data.length === 0) {
            // this.previewFields = [];

            this.previewData = [];
            return;
          }

          if (responseData?.previewData) {
            this.previewFields = responseData.previewFields;
            this.availablePreviewFields = responseData.previewFields;
            this.previewData = responseData.previewData;
            return;
          }

          if (
            Object.keys(responseData.data[0]).length !=
            this.availablePreviewFields.length
          ) {
            this.previewFields = Object.keys(responseData.data[0]);
            this.availablePreviewFields = Object.keys(responseData.data[0]);
          }
          this.previewData = responseData.data;
        })
        .finally(() => {
          this.loadingPreview = false;
        });
    },
    launch() {
      this.responseInfo = { status: null };
      const payload = {
        ...this.form,
      };
      ApiService.automationsApi
        .executeAutomation(payload)
        .then((resp) => {
          this.$notify.info({
            title: "Saved",
            message: "Good things just happened! You've triggered automation",
          });
          this.responseInfo = resp.data;
          // this.timeout = true;
          // this.timeout = setTimeout(() => {
          //   this.disabled = false;
          // }, 5000);
        })
        .catch((error) => alert(error));
    },
    // save() {
    //   this.$refs["mainForm"].validate((valid) => {
    //     if (valid) {
    //       ApiService.generalApi
    //         .saveTravelFeature(this.updatedPackage)
    //         .then((resp) => {
    //           this.$notify.success({
    //             title: "Success",
    //             message: "Saved",
    //           });
    //           this.$emit("close");
    //         });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    sendTest() {
      const payload = {
        ...this.form,
        test: true,
        testRecipient: this.testRecipient,
      };
      ApiService.automationsApi.executeAutomation(payload).then((resp) => {
        this.$notify.info({
          title: "Sending test",
          message: "Good things just happened! Yay.",
        });
      });
    },
    addRule() {
      this.form.rules.push({
        comparison: "=",
      });
      this.$forceUpdate();
    },
    addCustomRule() {
      this.form.custom_rules.push({
        comparison: "=",
      });
    },
    removeCustomRule(index) {
      this.form.custom_rules.splice(index, 1);
    },
    removeRule(index) {
      this.form.rules.splice(index, 1);
    },
    closeModal() {
      this.close();
    },
    onSubmit() {
      this.$refs["automationForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = {
          ...this.form,
        };
        if (this.id != 0) {
          payload.id = this.id;
        }

        if (
          payload.automation_type === "cron" ||
          payload.automation_type == "cron_event"
        ) {
          const dateOptions = {
            months: this.form.months,
            weeks: this.form.weeks,
            weekdays: this.form.weekdays,
            days: this.form.days,
            time: this.form.specific_time,
            dates: this.form.specific_date,
          };
          payload.date_options = JSON.stringify(dateOptions);
          payload.extra_options = JSON.stringify(payload.extra_options);
        }
        ApiService.automationsApi.saveAutomation(payload).then((resp) => {
          this.$notify.info({
            title: "Saved",
            message: "Good things just happened!",
          });
          this.$emit("close");
        });
      });
    },
    // executeAutomation() {
    //   this.responseInfo = { status: null };
    //   this.$refs["automationForm"].validate((valid) => {
    //     ApiService.automationsApi.executeAutomation(this.form).then((resp) => {
    //       this.responseInfo = resp.data;
    //       this.$notify.info({
    //         title: "Automation being launched",
    //         message: "Good things just happened!",
    //       });
    //       this.$forceUpdate();
    //       // this.$emit("close");
    //     });
    //   });
    // },
    updateOrgIds(newValue) {
      this.form.organization_ids = newValue.organization_id;
    },
    close() {
      this.$emit("close");
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
    openParent(userId) {
      this.$modal.show(
        SingleParent,
        {
          options: {
            profilePicture: true,
          },
          userId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 700,
          adaptive: true,
          width: 1100,
          // pivotY: 0
        },
        {
          // "before-close": this.beforeClose,
        }
      );
    },
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  mounted() {
    this.standardFieldOptionsObj = standardFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    this.perSchoolFieldOptionsObj = perSchoolFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    this.unregisteredWondeFieldOptionsObj =
      unregisteredWondeFieldOptions.reduce(
        (obj, cur) => ({ ...obj, [cur.value]: cur }),
        {}
      );
    this.stapDataFieldOptionsObj = stapDataFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    this.adminContactsFieldsOptionsObj = adminContactsFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    if (this.id != 0) {
      ApiService.automationsApi.getSingleAutomation(this.id).then((resp) => {
        const obj = resp.data;
        // this.form = obj;
        this.form.id = this.id;
        this.form.name = obj.name;
        this.form.automation_tags = obj.automation_tags
          ? obj.automation_tags.split(",")
          : [];
        this.form.content_type = obj.content_type;
        this.form.content_template_id = obj.content_template_id;
        this.form.user_type = obj.user_type;
        this.form.description = obj.description;
        this.form.automation_type = obj.automation_type;
        this.form.from_label = obj.from_label;
        this.form.template = obj.template;
        this.form.repeating = obj.repeating;
        this.form.when_to_launch = obj.when_to_launch;
        this.form.expire = obj.expire;
        this.form.script_name = obj.script_name;
        this.form.organization_ids = obj.organization_ids
          ? obj.organization_ids.split(",")
          : [];
        // this.form.organization_selection = [];
        this.form.rules = JSON.parse(obj.rules);
        this.form.selection_type =
          obj.selection_type == "BLACKLIST" ? true : false;
        // this.form.custom_rules = JSON.parse(obj.custom_rules);
        const dateOptions = JSON.parse(obj.date_options);
        this.form.specific_time = dateOptions.time;
        this.form.days = dateOptions.days ?? [];
        this.form.weeks = dateOptions.weeks ?? [];
        this.form.months = dateOptions.months ?? [];
        this.form.weekdays = dateOptions.weekdays ?? [];
        this.form.date_options = dateOptions;
        this.form.extra_options = JSON.parse(obj.extra_options);
        this.$forceUpdate();
        this.showSchoolFilter = true;
      });
    }
    this.showSchoolFilter = true;
    this.getTemplates("email");
    this.getTemplates("notice");
  },
});
</script>
<style scoped>
.longInput {
  min-width: 400px;
}

#statusResponseTable {
  background: white;
  padding: 3px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border: 1px solid #bbb;
  margin: auto;
  border-radius: 10px;
}

#statusResponseTable td {
  padding: 2px;
  min-width: 200px;
}

#statusResponseTable tr td:nth-child(1) {
  font-weight: bold;
}

table#statusResponseTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}

#previewTable {
  border-collapse: collapse;
}

#previewTable thead {
  position: sticky;
  /* make the table heads sticky */
  top: 0px;
  /* table head will be placed from the top of the table and sticks to it */
  box-shadow: 0px 1px 2px #ccc;
}

#previewTable thead th {
  padding: 0px 5px;
  /* border-right: 1px solid #bbb; */
}

hr {
  opacity: 0.5;
}

label {
  font-weight: bold;
  /* min-width: 160px; */
  display: inline-block;
  line-height: 40px;
}

span.inlineButton {
  padding-left: 15px;
  display: inline-block;
}

th.headSmallCol {
  font-size: 8px;
  background: #f9f9f9;
  padding: 5px 0;
  box-shadow: 0px 1px 2px #ccc;
}

th.headSmallCol:nth-child(2n + 2) {
  color: orange;
  background: #f3f3f3;
}

table#previewTable tbody tr:nth-child(2n) {
  background-color: whitesmoke;
}

td.tableCol {
  font-size: 9px;
  border: solid 1px #e6e6e6;
  border-left: 0;
  border-right: 0;
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 5px 0px;
}

td.tableCol:nth-child(2n + 2) {
  /* background: #fff8f2; */
}

.selectAllBtn {
  float: left;
  margin-top: 6px;
  margin-right: 5px;
}
</style>
